module.exports = __webpack_public_path__ + "img/20.59e3a7ba.jpg";